/* global angular */
angular.module('ua5App')
    .directive('resourceTimeline', ['$state', '$timeout', '$rootScope', '$sce', function($state, $timeout, $rootScope, $sce) {
        return {
            restrict: 'A',
            templateUrl: 'components/resource-timeline/resource-timeline.html',
            scope: {
                content: '=',
                contentTitle: '@',
                sectionIndex: '@'
            },
            link: function($scope, element, attrs) {
                // content should be an array of objects with {date, body, photo (optional)}
                for (var i = 0; i < $scope.content; i++) {
                    $scope.content[i].body = $sce.trustAsHtml($scope.content[i].body);
                }

                $scope.sortByRank = function(item) {
                    return parseInt(item.rank, 10);
                };

                $timeout(function() {
                    $rootScope.$broadcast('resourceComponentPosition', {sectionIndex: $scope.sectionIndex});
                });
            }
        };
    }])
;
